import { render } from "./RuleDialog.vue?vue&type=template&id=56ea0b35&scoped=true"
import script from "./RuleDialog.vue?vue&type=script&lang=js"
export * from "./RuleDialog.vue?vue&type=script&lang=js"

import "./RuleDialog.vue?vue&type=style&index=0&id=56ea0b35&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ea0b35"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});qInstall(script, 'directives', {ClosePopup});
